// whatsapp icon component
import { FaWhatsapp } from 'react-icons/fa';
import '../styles/whatsappicon.css';

//add a whatsapp icon to the bottom of the page 
const WhatsappIcon = () => {
  return (
    <div className="whatsapp-icon">
      <a href="https://wa.me/250793761875">
        <FaWhatsapp className="whatsapp-icon-icon" />
      </a>
    </div>
  );
};

export default WhatsappIcon;
